import { useApiPatch } from "../../../../../lib/api";
import type { Profile } from "../../../../types/profile";

type UpdateProfileInput = {
  name?: string | null;
  avatar_url?: string | null;
  breakfast_food?: string | null;
  emergency_contact_name?: string | null;
  emergency_contact_number?: string | null;
  bio?: string | null;
  instagram?: string | null;
  strava_code?: string | null;
};

export const useUpdateProfile = (profileId: string, callback: () => void) => {
  const { mutate, isPending } = useApiPatch<
    { profile: Profile },
    UpdateProfileInput
  >(`/api/v1/profiles/${profileId}`, {
    onSuccess: () => {
      callback();
    },
    onError: (error) => {
      console.error(error);
    },
  });

  const handleUpdateProfile = (input: UpdateProfileInput) => {
    mutate(input);
  };

  return [handleUpdateProfile, isPending] as const;
};
